import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";
import { camelToSnake, snakeToCamel } from "caseparser";

export const brandApi = api
  .enhanceEndpoints({ addTagTypes: ["brand", "pre-recorded-video"] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      updateBrand: builder.mutation({
        query: ({ gymData }) => ({
          url: `/branch/brand`,
          method: RequestMethod.POST,
          body: gymData,
        }),
      }),

      preRedordedClasses: builder.query({
        query: ({ branchId, search }) => ({
          url: `branchs/${branchId}/brand/pre-recorded-video?search=${search}`,
          method: RequestMethod.GET,
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
        providesTags: ["pre-recorded-video"],
      }),
      storePreRedordedClasses: builder.mutation({
        query: (gymData) => ({
          url: `branchs/${gymData.branchId}/brand/pre-recorded-video`,
          method: RequestMethod.POST,
          body: gymData,
        }),
      }),
      updatePreRedordedClasses: builder.mutation({
        query: (gymData) => ({
          url: `branchs/${gymData.branchId}/brand/pre-recorded-video/${gymData.videoId}`,
          method: RequestMethod.PUT,
          body: gymData,
        }),
      }),
      deletePreRedordedClasses: builder.mutation({
        query: ({ branchId, videoId }) => ({
          url: `branchs/${branchId}/brand/pre-recorded-video/${videoId}`,
          method: RequestMethod.DELETE,
        }),
      }),
    }),
  });

export const {
  useUpdateBrandMutation,
  usePreRedordedClassesQuery,
  useStorePreRedordedClassesMutation,
  useUpdatePreRedordedClassesMutation,
  useDeletePreRedordedClassesMutation,
} = brandApi;
